import React from 'react';
import { NavLink } from 'react-router-dom';
import './styles.scss';

const MenuLink = ({ isAllowed, className, ...rest }) =>
  isAllowed ? <NavLink className={`styled-link ${className ? className : ''} list-group-item`} {...rest} /> : null;

export default MenuLink;
